import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoAccessIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 500,
	height: 500,
	viewBox: "0 0 500 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M246.895 424.348C336.641 424.348 409.395 351.594 409.395 261.848C409.395 172.101 336.641 99.3477 246.895 99.3477C157.149 99.3477 84.395 172.101 84.395 261.848C84.395 351.594 157.149 424.348 246.895 424.348Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.015 177.438L61.335 195.118C60.115 196.338 58.135 196.338 56.915 195.118C55.695 193.898 55.695 191.918 56.915 190.698L74.595 173.018C75.815 171.798 77.795 171.798 79.015 173.018C80.235 174.238 80.235 176.218 79.015 177.438Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0148 195.118C77.7948 196.338 75.8148 196.338 74.5948 195.118L56.9248 177.438C55.7048 176.218 55.7048 174.238 56.9248 173.018C58.1448 171.798 60.1248 171.798 61.3448 173.018L79.0248 190.698C80.2448 191.918 80.2448 193.898 79.0248 195.118H79.0148Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M442.725 250.558L430.705 262.578C429.875 263.408 428.525 263.408 427.695 262.578C426.865 261.748 426.865 260.398 427.695 259.568L439.715 247.548C440.545 246.718 441.895 246.718 442.725 247.548C443.555 248.378 443.555 249.728 442.725 250.558Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M442.725 262.578C441.895 263.408 440.545 263.408 439.715 262.578L427.695 250.558C426.865 249.728 426.865 248.378 427.695 247.548C428.525 246.718 429.875 246.718 430.705 247.548L442.725 259.568C443.555 260.398 443.555 261.748 442.725 262.578Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M246.895 424.348C336.641 424.348 409.395 351.594 409.395 261.848C409.395 172.101 336.641 99.3477 246.895 99.3477C157.149 99.3477 84.395 172.101 84.395 261.848C84.395 351.594 157.149 424.348 246.895 424.348Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M337.515 171.018H180.825C165.505 171.018 153.085 183.437 153.085 198.758V342.338C153.085 357.658 165.505 370.078 180.825 370.078H337.515C352.835 370.078 365.255 357.658 365.255 342.338V198.758C365.255 183.437 352.835 171.018 337.515 171.018Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M336.255 161.018H157.525C146.706 161.018 137.935 169.788 137.935 180.608V341.078C137.935 351.897 146.706 360.668 157.525 360.668H336.255C347.074 360.668 355.845 351.897 355.845 341.078V180.608C355.845 169.788 347.074 161.018 336.255 161.018Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.525 161.018H336.265C347.075 161.018 355.855 169.798 355.855 180.608V190.878H137.935V180.608C137.935 169.798 146.715 161.018 157.525 161.018Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.935 181.237C194.509 181.237 196.595 179.151 196.595 176.577C196.595 174.004 194.509 171.917 191.935 171.917C189.361 171.917 187.275 174.004 187.275 176.577C187.275 179.151 189.361 181.237 191.935 181.237Z",
			fill: "#9AEDE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.835 181.237C176.409 181.237 178.495 179.151 178.495 176.577C178.495 174.004 176.409 171.917 173.835 171.917C171.262 171.917 169.175 174.004 169.175 176.577C169.175 179.151 171.262 181.237 173.835 181.237Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M155.745 181.237C158.319 181.237 160.405 179.151 160.405 176.577C160.405 174.004 158.319 171.917 155.745 171.917C153.171 171.917 151.085 174.004 151.085 176.577C151.085 179.151 153.171 181.237 155.745 181.237Z",
			fill: "#FFCAC5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.505 279.157H286.275C296.395 279.157 304.615 287.377 304.615 297.497V323.277C304.615 355.137 278.745 381.007 246.885 381.007C215.025 381.007 189.155 355.137 189.155 323.277V297.497C189.155 287.377 197.375 279.157 207.495 279.157H207.505Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M288.775 269.897H277.015V252.407C277.015 235.797 263.505 222.287 246.895 222.287C230.285 222.287 216.775 235.797 216.775 252.407V269.897H205.015V252.407C205.015 229.317 223.805 210.527 246.895 210.527C269.985 210.527 288.775 229.317 288.775 252.407V269.897Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M246.395 332.657C252.989 332.657 258.335 327.312 258.335 320.717C258.335 314.123 252.989 308.777 246.395 308.777C239.801 308.777 234.455 314.123 234.455 320.717C234.455 327.312 239.801 332.657 246.395 332.657Z",
			fill: "#002F75"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M246.395 348.997C244.415 348.997 242.815 347.397 242.815 345.417V328.357C242.815 326.377 244.415 324.777 246.395 324.777C248.375 324.777 249.975 326.377 249.975 328.357V345.417C249.975 347.397 248.375 348.997 246.395 348.997Z",
			fill: "#002F75"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.445 77.6575L212.235 86.4475C212.845 87.0575 213.825 87.0575 214.435 86.4475C215.045 85.8375 215.045 84.8575 214.435 84.2475L205.645 75.4575C205.035 74.8475 204.055 74.8475 203.445 75.4575C202.835 76.0675 202.835 77.0475 203.445 77.6575Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.445 86.4475C204.055 87.0575 205.035 87.0575 205.645 86.4475L214.435 77.6575C215.045 77.0475 215.045 76.0675 214.435 75.4575C213.825 74.8475 212.845 74.8475 212.235 75.4575L203.445 84.2475C202.835 84.8575 202.835 85.8375 203.445 86.4475Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M395.815 176.118H376.055",
			stroke: "#9EC5FF",
			strokeWidth: 7.65,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M379.815 139.788L365.215 154.388",
			stroke: "#9EC5FF",
			strokeWidth: 7.65,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M383.075 136.528L379.815 139.788",
			stroke: "#9EC5FF",
			strokeWidth: 7.65,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M343.705 123.788V143.558",
			stroke: "#9EC5FF",
			strokeWidth: 7.65,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgNoAccessIllustration;
